import { render } from "./HomeAboutUs.vue?vue&type=template&id=e566a3aa"
import script from "./HomeAboutUs.vue?vue&type=script&lang=js"
export * from "./HomeAboutUs.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__